<div (click)="stopTimer()" class="dialog-container">
    <div class="dialog-header">
        <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-content">
        <ng-container #dynamicComponentContainer></ng-container>
    </div>

    <div [class.visible]="showProgressBar" class="progress-bar">
        <div [style.transition-duration]="(duration / 1000) + 's'" [style.width.%]="progressValue"
             class="progress-fill"></div>
    </div>
</div>
